
I listened to [Peaceful Summer Nights](https://open.spotify.com/playlist/37i9dQZF1DWTjLfR5thd2p) while writing this FYI. Alas, I know it is not summertime yet.

# What are you getting at?

> He asks himself in the third person.

```
Him: "All you need is love."
Her: "Please don't start that again.
Him: "All you need is love."
Her: "A girl has got to eat."
```

So, yes, I watched Moulin Rouge recently but far enough back now that it is weird in this moment I decided to quote that...

I'm 26 years old. The average male life expectancy in the United States as of 2016 was 78.69 years old.

26 / 78.69 = 33.0410471%

I have completed roughly 33% of my life thus far. I'm at a 1/3 life crisis of sorts.

Ever heard of the optimal stopping problem? Or rather, some call it the secretary problem as well. Actually, it has many names:

- marriage problem
- sultan’s dowry problem
- best choice problem

> Imagine an administrator who wants to hire the best secretary out of n rankable applicants for a position. The applicants are interviewed one by one in random order. A decision about each particular applicant is to be made immediately after the interview. Once rejected, an applicant cannot be recalled. During the interview, the administrator can rank the applicant among all applicants interviewed so far but is unaware of the quality of yet unseen applicants.

According to a bit o' math, the optimal win probability is always at least 1/e.

The optimal stopping rule prescribes always rejecting the first n/e applicants that are interviewed (where e is the base of the natural logarithm and has the value 2.71828) and then stopping at the first applicant who is better than every applicant interviewed so far (or continuing to the last applicant if this never occurs). This strategy is called the 1/e stopping rule because the probability to select the best candidate is 1/e, in other words, this strategy selects the best candidate about 37% of time.

Ok, so I have roughly 4% more of life before I should start embracing my decisions and putting down roots? But what if we add a little Freud and Erikson in the mix and say that I only _truly_ began to see the world properly at age 13.

(26 - 13) / (78.69 - 13) = 19.789922362% which means if I wait until 37.3053 yrs old that's when I'll really be at the peak of my game.

So let's be sure not to stop until then.

# Some housing mathematics

Drew, a friend from Atlanta wants to move to NYC. "So what are some of the least expensive neighbordhood in the city to look for?", he asks. I immediately rattled off Upper East Side and Brooklyn which seemed to shock him that UES (acronym for everything north of Central Park) made the cut. Firstly, for our generation, Upper East is not necessarily a place where people want to be while young. There's not much up that way to be honest.

We also talked about what it would take to get here and I recommended $80k as a minimum before taxes to live comfortably. Let's do a wee bit o math for this.

$80,000 * .7 for taxes / 12 = $4.666,66 monthly

And then we take 30% of your total comp which turns out to be

4,666 * .3 = $1,399.8 which is a pretty small apartment in most of Manhattan but very doable finding the right place.

# Work/life balance

The key to your upper 20s is sustenance. Not as it relates to food but rather as it relates to the word sustain. You get to a place like NYC with the go-getter attitude and just like freshman year of college you want to suck the marrow of life and do all the things but you overextend yourself and you end up tanking sometimes. The key is finding the right balance. You can do all the things but you need to set aside recharge time or else you'll burn out.

> **Rule 1:**
> no meetings 1 day a week

I know this is super hard depending on the job but it does wonders for the soul if you can get away with it.

> **Rule 2:**
> gym 3 days a week minimum

If you don't have a gym then not to worry you should be able to find some other way to get exercise. Gym time and the like grounds you and focuses the mind without any intentional thought like meditation. It's an easy way to ground yourself more or less.

> **Rule 3:**
> 2 ears and 1 mouth

Listen first and talk only when you believe it is necessary. Especially on a new team or in a new job. Be in the room but don't talk for the first bits of meetings until you've thought through concise ways to speak up.

> **Rule 4:**
> Strong opinions, loosely held

Strong opinions and fighting for such are not wholly bad things together when you maintain a level of viscosity and malleability.

> **Rule 5:**
> +/- get better every day

This one is pretty self explanatory. Make sure the day is net positive.

# Looking up

Who do you look up to? If you're not looking up then you're looking within which might mean an ego problem. 



